import type { FC, ReactNode } from "react";
import { Redirect } from "react-router-dom";
import { PATH_HOME, PATH_SUPERADMIN } from "src/routesConstants";
import { isAdminUser } from "src/utils/permission";
import useAuth from "../hooks/useAuth";
import { isUserEnabled } from "../utils/shouldDisplayEntity";

interface GuestGuardProps {
    children?: ReactNode;
}

const GuestGuard: FC<GuestGuardProps> = ({ children }) => {
    const { isAuthenticated, user } = useAuth();

    if (isAuthenticated && isUserEnabled(user)) {
        if (isAdminUser(user)) {
            return <Redirect to={PATH_SUPERADMIN} />;
        }
        return <Redirect to={PATH_HOME} />;
    }

    return <>{children}</>;
};

export default GuestGuard;
